import { Card, CardContent, CardHeader, SxProps } from '@mui/material'
import { CSSProperties } from 'react'

import { InlineLoader } from './InlineLoader'

type Props = {
  children: React.ReactNode
  title?: string
  action?: React.ReactNode | React.ReactNode[]
  noPadding?: boolean
  height?: number | string
  isFlex?: boolean
  isColumn?: boolean
  isLoading?: boolean
  isLoadingMessage?: string
  isError?: boolean
  data?: boolean
  textAlign?: CSSProperties['textAlign']
  sx?: SxProps
  headerSx?: object
  raised?: boolean
  elevation?: number
  showErrorBorder?: boolean
}

export const ContentCard = ({
  title,
  action,
  children,
  noPadding,
  height,
  isFlex = false,
  isColumn = false,
  isLoading = false,
  isLoadingMessage = 'Loading...',
  isError = false,
  textAlign = 'inherit',
  data = true,
  sx = {},
  headerSx = {},
  raised = undefined,
  elevation = 1,
  showErrorBorder = false,
}: Props) => {
  const applyHeight = height ? { height } : {}
  const errorBorder = showErrorBorder
    ? {
        border: '2px solid',
        borderColor: 'error.main',
        boxShadow: 3,
        borderRadius: 3,
      }
    : {}

  const sxFinal: SxProps = {
    ...(noPadding ? { padding: '0px !important' } : {}),
    ...applyHeight,
    ...(isFlex ? { display: 'flex !important' } : { display: 'block' }),
    ...(isColumn ? { flexDirection: 'column' } : { flexDirection: 'row' }),
    ...sx,
    textAlign,
  }

  return (
    <Card
      sx={{ ...applyHeight, ...errorBorder }}
      role={title ? 'region' : undefined}
      aria-label={title || undefined}
      raised={raised}
      elevation={elevation}
    >
      {!!title && (
        <CardHeader
          title={title}
          action={action}
          sx={{ pb: 0, color: 'rgb(59, 26, 89)', ...headerSx }}
          slotProps={{
            title: { component: 'h2', variant: 'h2' },
          }}
        />
      )}
      <CardContent sx={sxFinal}>
        {isLoading || isError || !data ? <InlineLoader message={isLoadingMessage} /> : children}
      </CardContent>
    </Card>
  )
}
